import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ItemsDropDownDto } from './items-drop-down.dto';
import { RmBomDetails } from './rm-bom-details';
import { RmBomDto } from './rm-bom.dto';
import { RmBomData } from './rmBomData';


export class SORmBomResponse extends GlobalResponseObject {
    data?: RmBomDetails[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ItemsDropDownDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RmBomDetails[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
